// extracted by mini-css-extract-plugin
export default {"root":"Avatar_root__YJ1rU","layout-container":"Avatar_layout-container__y9T1z","BehaviorContainer":"Avatar_BehaviorContainer__F1ldK","behavior":"Avatar_behavior__QfBnX","option":"Avatar_option__4K95B","content":"Avatar_content__xaRn7","greetingContainer":"Avatar_greetingContainer__9rDBG","header":"Avatar_header__J-7sC","switch":"Avatar_switch__-NuwR","slider":"Avatar_slider__uXfrO","avatarContainer":"Avatar_avatarContainer__3z+ac","saveButton":"Avatar_saveButton__do7xG"};
    if(module.hot) {
      // 1763446808782
      var cssReload = require("/usr/src/app/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  